/*
 * Copyright (c) 2023-2025 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { Button, Typography } from 'antd'
import { ReactNode } from 'react'
import { useNotification } from '../../hooks/useNotification'

import { CloseOutlined } from '@ant-design/icons'

export function Notification({
  notificationKey,
  title,
  content
}: {
  notificationKey: string
  title: ReactNode | string
  content?: ReactNode | string
}) {
  const messageApi = useNotification()

  return (
    <div className="ab-notification">
      <div className="flex gap-x-2">
        <Typography className="flex-1 text-base" aria-label={title?.toString()}>
          {title}
        </Typography>

        <Button
          type="text"
          shape="circle"
          icon={<CloseOutlined className="[&>svg]:text-xs" />}
          className="flex items-center justify-center"
          aria-label="Close notification"
          onClick={() => messageApi.destroy(notificationKey)}
        />
      </div>

      {content && <Typography className="text-sm">{content}</Typography>}
    </div>
  )
}
